import { combineReducers } from 'redux';
import {reducerMenus as menus,reducerNavigation as nav,reducerLogin as login}from "./reducer";

export default combineReducers({
    menus,
    nav,
    login,
})
